import React from 'react'
import { getUserName } from '../../helpers/user/UserHelper'

const ChangeUser = ({ user }) => {
  return (
    <div>
        {/* {user.name} {user.surname} */}
		{
			getUserName({ user })
		}
    </div>
  )
}

export default ChangeUser